import { render, staticRenderFns } from "./FundReport.vue?vue&type=template&id=5f2616b9&scoped=true&"
import script from "./FundReport.vue?vue&type=script&lang=js&"
export * from "./FundReport.vue?vue&type=script&lang=js&"
import style0 from "./FundReport.vue?vue&type=style&index=0&id=5f2616b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2616b9",
  null
  
)

export default component.exports